import { render, staticRenderFns } from "./LoginGrp.vue?vue&type=template&id=6c50887c&scoped=true&"
import script from "./LoginGrp.vue?vue&type=script&lang=js&"
export * from "./LoginGrp.vue?vue&type=script&lang=js&"
import style0 from "./LoginGrp.vue?vue&type=style&index=0&id=6c50887c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50887c",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QColor} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QColor})
